import React from 'react';
import {
  string, number, oneOf, func, shape, arrayOf
} from 'prop-types';
import styles from './message.module.css';
import { messageTypeValues } from '../../../constants/types';

const NUM_DETAILS_TO_DISPLAY = 3;

const Message = ({
  translate, messageType, close, details, text
}) => {
  let messageStyle;
  let messageContent;
  // Styleguide also supports message style 'status'. Add here if needed.
  switch (messageType) {
    case messageTypeValues.INFO:
      messageStyle = 'info';
      messageContent = (
        <div className={styles.messageContent}>
          <p>{text}</p>
        </div>
      );
      break;
    case messageTypeValues.ERROR:
      messageStyle = 'error';
      messageContent = (
        <div className={styles.messageContent}>
          <h2 className={styles.errorTitle}>{translate('connectionError')}</h2>
          {details && details.slice(-NUM_DETAILS_TO_DISPLAY).map((message) =>
            <p key={message.id}>{translate('errorInResponseTo')} {message.url}: {message.code} – {message.message}</p>)}
        </div>
      );
      break;
    default:
  }

  return (
    <div className={`messages ${messageStyle} ${styles.messageBlock}`} data-cy="message">
      {messageContent}
      <button
        type="button"
        onClick={close}
        className={`${styles.closeButton} icon--remove iconButton`}
        title={translate('common.remove')}
      />
    </div>
  );
};

Message.propTypes = {
  close: func.isRequired,
  messageType: oneOf(Object.values(messageTypeValues)).isRequired,
  details: arrayOf(shape({
    message: string,
    url: string,
    code: number
  })).isRequired,
  text: string.isRequired,
  translate: func.isRequired
};

export default Message;
